import { ReactNode, useEffect } from 'react'

import { loadRecaptchaEnterprise } from '@/infra/recaptcha/recaptcha-enterprise-loader'
import errorMonitor from '@/infra/tracking/error-monitor'
import { settings } from '@/main/config/settings'

/**
 * Define onde o script do reCAPTCHA é carregado e, por consequência, onde o Account Defender
 * coleta. Único arquivo a mudar para estreitar essa pegada.
 *
 * Envolve toda a aplicação porque o Account Defender precisa da jornada completa, inclusive
 * páginas logadas: sem histórico de navegação, um acesso via NAT/VPN corporativa é
 * indistinguível de bot. Carregar não gera assessment nem custo — a cobrança é por
 * {@code CreateAssessment} no backend.
 *
 * Nunca chama {@code execute()}; falha aqui não bloqueia fluxo protegido, porque o provider
 * aguarda a mesma promessa memoizada do loader por conta própria.
 */
export const RecaptchaTelemetry = ({ children }: { children?: ReactNode }) => {
  useEffect(() => {
    // Sem kill switch ligado ou sem chave, não há nada a alimentar.
    if (!settings.RECAPTCHA_ENABLED || !settings.RECAPTCHA_SITE_KEY_V3) {
      return
    }

    loadRecaptchaEnterprise(settings.RECAPTCHA_SITE_KEY_V3).catch((error: unknown) => {
      // Best-effort: só registra.
      errorMonitor.captureException(error, {
        tags: { feature: 'recaptcha-telemetry' },
        level: 'warning'
      })
    })
  }, [])

  return <>{children}</>
}
